<template>
  <loading-page v-if="isLoading"></loading-page>
  <div v-else class="container-product-items">
    <category-banner></category-banner>
    <div class="breadcrumbs-container">
    <el-breadcrumb :separator-icon="CustomSeparator">
      <el-breadcrumb-item to="/">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
        >
          <path
            d="M26.8134 13.7498C26.8134 13.5674 26.741 13.3926 26.612 13.2636C26.4831 13.1347 26.3082 13.0623 26.1259 13.0623C25.9436 13.0623 25.7687 13.1347 25.6398 13.2636C25.5108 13.3926 25.4384 13.5674 25.4384 13.7498H26.8134ZM7.56338 13.7498C7.56338 13.5674 7.49094 13.3926 7.36201 13.2636C7.23308 13.1347 7.05821 13.0623 6.87587 13.0623C6.69354 13.0623 6.51867 13.1347 6.38974 13.2636C6.26081 13.3926 6.18837 13.5674 6.18837 13.7498H7.56338ZM28.3892 16.9865C28.5183 17.1156 28.6933 17.1882 28.8759 17.1882C29.0585 17.1882 29.2336 17.1156 29.3627 16.9865C29.4918 16.8574 29.5643 16.6824 29.5643 16.4998C29.5643 16.3172 29.4918 16.1421 29.3627 16.013L28.3892 16.9865ZM16.5009 4.12477L16.9876 3.63801C16.9238 3.57399 16.8479 3.52319 16.7644 3.48853C16.6809 3.45388 16.5913 3.43604 16.5009 3.43604C16.4105 3.43604 16.3209 3.45388 16.2374 3.48853C16.1539 3.52319 16.078 3.57399 16.0141 3.63801L16.5009 4.12477ZM3.63912 16.013C3.51002 16.1421 3.4375 16.3172 3.4375 16.4998C3.4375 16.6824 3.51002 16.8574 3.63912 16.9865C3.76821 17.1156 3.9433 17.1882 4.12587 17.1882C4.30844 17.1882 4.48353 17.1156 4.61262 16.9865L3.63912 16.013ZM9.62588 29.5623H23.3759V28.1873H9.62588V29.5623ZM26.8134 26.1248V13.7498H25.4384V26.1248H26.8134ZM7.56338 26.1248V13.7498H6.18837V26.1248H7.56338ZM29.3627 16.013L16.9876 3.63801L16.0141 4.61152L28.3892 16.9865L29.3627 16.013ZM16.0141 3.63801L3.63912 16.013L4.61262 16.9865L16.9876 4.61152L16.0141 3.63801ZM23.3759 29.5623C24.2876 29.5623 25.1619 29.2001 25.8066 28.5555C26.4512 27.9108 26.8134 27.0365 26.8134 26.1248H25.4384C25.4384 26.6718 25.2211 27.1964 24.8343 27.5832C24.4475 27.97 23.9229 28.1873 23.3759 28.1873V29.5623ZM9.62588 28.1873C9.07887 28.1873 8.55426 27.97 8.16747 27.5832C7.78067 27.1964 7.56338 26.6718 7.56338 26.1248H6.18837C6.18837 27.0365 6.55054 27.9108 7.1952 28.5555C7.83985 29.2001 8.7142 29.5623 9.62588 29.5623V28.1873Z"
            fill="black"
            fill-opacity="0.6"
          />
        </svg>
      </el-breadcrumb-item>
      <el-breadcrumb-item
        :to="selectedCategory"
        >{{selectedCategory }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
    <div class="product-container">
      <base-product
        v-for="product in getAllProducts"
        :key="product._id"
        :img-url="product.image"
        :product-title="product.name"
        :product-price="product.price"
        :product-category="product.category"
        :product-id="product._id"
        :product-color="product.color"
      ></base-product>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { h } from "vue";

export default {
  data() {
    return {
      selectedCategory: 'All items',
      CustomSeparator: h("div", {
        style: `
        width: 50px;
        height: 1px;
        background: rgba(0, 0, 0, 0.60);
        `,
      }),
    }
  },
  computed: {
    ...mapGetters(["getAllProducts", "isLoading"]),

    filteredProducts() {
      return this.getAllProducts();
    },
  },
};
</script>

<style scoped>
.breadcrumbs-container {
  padding: 40px 40px 0px 40px;
}

::v-deep(.el-icon) {
  width: 5rem;
}

::v-deep(.breadcrumb__inner.is-link):hover {
  color: #000 !important;
}

.el-breadcrumb {
  display: flex;
  align-items: center;
}

::v-deep(.el-breadcrumb__inner) {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 500;
}
</style>




